import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import apiMiddleware from '../middlewares/apiMiddleware';
//import { logger } from '../middleware';

import rootReducer from './configureReducers';


export function configureStore(initialState) {
  const create = window.devToolsExtension
    ? window.devToolsExtension()(createStore)
    : createStore;

  const createStoreWithMiddleware = applyMiddleware(
    //logger,
    thunkMiddleware,
    apiMiddleware,
  )(create);

  const store = createStoreWithMiddleware(rootReducer, initialState);

  if (module.hot) {
    module.hot.accept('./configureReducers', () => {
      const nextReducer = require('./configureReducers');
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js